import React from 'react'

const Button = (props) => {
  return (
    <a href='/' className={`button bg-${props.color} ${props.size} c-white`}>{props.text}</a>
  )
}

export { Button }
